// @generated by protoc-gen-connect-query v2.3.1 with parameter "target=ts"
// @generated from file travplaces/v1/saved_route.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import { SavedRouteService } from "./saved_route_pb";

/**
 * ListSavedRoutes returns an owner's saved routes, newest first.
 *
 * @generated from rpc travplaces.v1.SavedRouteService.ListSavedRoutes
 */
export const listSavedRoutes = SavedRouteService.method.listSavedRoutes;

/**
 * GetSavedRoute returns one saved route by id.
 *
 * @generated from rpc travplaces.v1.SavedRouteService.GetSavedRoute
 */
export const getSavedRoute = SavedRouteService.method.getSavedRoute;

/**
 * SaveRoute persists a new route for an owner.
 *
 * @generated from rpc travplaces.v1.SavedRouteService.SaveRoute
 */
export const saveRoute = SavedRouteService.method.saveRoute;

/**
 * UpdateSavedRoute updates a route's name, plan and notes.
 *
 * @generated from rpc travplaces.v1.SavedRouteService.UpdateSavedRoute
 */
export const updateSavedRoute = SavedRouteService.method.updateSavedRoute;

/**
 * DeleteSavedRoute removes a saved route by id.
 *
 * @generated from rpc travplaces.v1.SavedRouteService.DeleteSavedRoute
 */
export const deleteSavedRoute = SavedRouteService.method.deleteSavedRoute;

/**
 * PoiCoverage says which of these places have been covered before, by whom
 * and for how long. Read-only, and read from work already saved.
 *
 * @generated from rpc travplaces.v1.SavedRouteService.PoiCoverage
 */
export const poiCoverage = SavedRouteService.method.poiCoverage;

/**
 * PlaceTallies says how many saved plans stop at each place in a city:
 * one figure apiece, rather than each place's whole history.
 *
 * @generated from rpc travplaces.v1.SavedRouteService.PlaceTallies
 */
export const placeTallies = SavedRouteService.method.placeTallies;
